var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.609 3.08254L6.18032 7.51057C5.7393 7.95152 4.43017 8.15575 4.13771 7.86333C3.84525 7.57091 4.04486 6.26199 4.48588 5.82104L8.91925 1.38836C9.02857 1.2691 9.16093 1.17323 9.30836 1.10653C9.45576 1.03983 9.61517 1.00367 9.77695 1.00026C9.93869 0.996863 10.0995 1.02626 10.2496 1.0867C10.3997 1.14714 10.536 1.23737 10.6502 1.35192C10.7645 1.46648 10.8543 1.60299 10.9144 1.75321C10.9744 1.90345 11.0034 2.06428 10.9995 2.22601C10.9957 2.38775 10.9591 2.54704 10.892 2.69425C10.8249 2.84146 10.7286 2.97355 10.609 3.08254Z",
    stroke: "#6AA13C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49988 2H2.99988C2.46944 2 1.96077 2.21071 1.58569 2.58578C1.21062 2.96086 0.999878 3.46956 0.999878 4V9C0.999878 9.53045 1.21062 10.0391 1.58569 10.4142C1.96077 10.7893 2.46944 11 2.99988 11H8.49988C9.60488 11 9.99988 10.1 9.99988 9V6.5",
    stroke: "#6AA13C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.f0494317c4b8e0608fe0dcb8d85cf371.svg";
export { ForwardRef as ReactComponent };